import { Injectable, NgZone } from '@angular/core';
import Pusher from 'pusher-js';
import { Document } from '../order-documents/order-documents.service';
import { config } from 'config';

export interface FailedUpload {
  error: string;
  timestamp: string;
}

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private pusher: Pusher;
  private subscribedChannels: Set<string> = new Set();


  constructor(private ngZone: NgZone) {
    this.pusher = new Pusher(config.pusher.key, {
      cluster: config.pusher.cluster,
      wsHost: config.pusher.wHost,
      wsPort: config.pusher.wPort,
      wsPath: config.pusher.wsPath,
      forceTLS: config.pusher.forceTLS,
      disableStats: config.pusher.disableStats,
      enabledTransports: ['ws', 'wss'],
    });

    this.pusher.connection.bind('connected', () => {
      console.log('✅ Pusher connected!');
    });
    this.pusher.connection.bind('state_change', (states) => {
      console.log('🔄 Pusher state changed:', states);
    });

  }

  /**
   * Listens to upload status events and returns both success and failure callbacks.
   */
  listenToUploadStatus(
    sessionId: string,
    onSuccess: (document: Document) => void,
    onFailure: (error?: FailedUpload) => void
  ): void {
    const channelName = `upload-status.${sessionId}`;

    // Unsubscribe first to avoid duplicate bindings
    if (this.subscribedChannels.has(channelName)) {
      console.log('🔁 Resubscribing to', channelName);
      this.unsubscribe(sessionId);
    }

    console.log('🔔 Subscribing to', channelName);
    const channel = this.pusher.subscribe(channelName);

    channel.bind('upload-status-update', (data: any) => {
      this.ngZone.run(() => {
        console.log('📡 Upload status update:', data);

        if (data.status === 'uploaded') {
          onSuccess(data.document);
        } else if (data.status === 'failed') {
          onFailure(data.error || 'Unknown error');
        }
      });
    });
  }


  unsubscribe(sessionId: string): void {
    const channelName = `upload-status.${sessionId}`;
    console.log('🚪 Unsubscribing from', channelName);

    this.pusher.unsubscribe(channelName);
    this.subscribedChannels.delete(channelName);
  }
}
